<template>
  <div class="row mx-0 credit-line">
    <div class="col-12 text-center fs-7 fw-lighter text-muted">توسعه داده شده با افتخار توسط تیم توسعه نرم افزاری شورای همبستگی آزادی برای ایران</div>
  </div>
</template>
